/** A format or time slot needs at least this many posts before it is ranked. */
export const MIN_INSIGHT_POSTS = 3;
/** Only used before the backend's `min_post_age_days` has arrived. */
export const DEFAULT_MIN_POST_AGE_DAYS = 7;
